import { render, staticRenderFns } from "./grievance-details.vue?vue&type=template&id=358565ec&scoped=true&"
import script from "./grievance-details.vue?vue&type=script&lang=js&"
export * from "./grievance-details.vue?vue&type=script&lang=js&"
import style0 from "./grievance-details.vue?vue&type=style&index=0&id=358565ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358565ec",
  null
  
)

export default component.exports